// get_certificate_student
export const GET_CERTIFICATE_STUDENT = 'get_certificate_student';
export const GET_CERTIFICATE_STUDENT_SUCCESSFUL =
  'get_certificate_student_successfull';
export const GET_CERTIFICATE_STUDENT_FAILED = 'get_certificate_student_failed';

// create_certificate_student
export const CREATE_CERTIFICATE_STUDENT = 'create_certificate_student';
export const CREATE_CERTIFICATE_STUDENT_SUCCESSFUL =
  'create_certificate_student_successfull';
export const CREATE_CERTIFICATE_STUDENT_FAILED =
  'create_certificate_student_failed';

// update_certificate_student
export const UPDATE_CERTIFICATE_STUDENT = 'update_certificate_student';
export const UPDATE_CERTIFICATE_STUDENT_SUCCESSFUL =
  'update_certificate_student_successfull';
export const UPDATE_CERTIFICATE_STUDENT_FAILED =
  'update_certificate_student_failed';

// delete_certificate_student
export const DELETE_CERTIFICATE_STUDENT = 'delete_certificate_student';
export const DELETE_CERTIFICATE_STUDENT_SUCCESSFUL =
  'delete_certificate_student_successfull';
export const DELETE_CERTIFICATE_STUDENT_FAILED =
  'delete_certificate_student_failed';
